import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { BillingRoutingModule } from "./billing-routing.module";

import { BillingComponent } from "./billing.component";
import { TransactionHistoryComponent } from "./transaction-history/transaction-history.component";
import { SharedModule } from "@shared";
import { NzCollapseModule } from "ng-zorro-antd/collapse";
import { NzSkeletonModule } from "ng-zorro-antd/skeleton";
import { NzResultModule } from "ng-zorro-antd/result";
import { NzPageHeaderModule } from "ng-zorro-antd/page-header";
import { AngularImageViewerModule } from "@clarivate/angular-image-viewer";
import { NgxExtendedPdfViewerModule } from "ngx-extended-pdf-viewer";
import { TitleCaseNoUnderScorePipe } from "@core";



@NgModule({
    declarations:[
        BillingComponent,
        TransactionHistoryComponent,
    ],
    imports:[
        CommonModule,
        BillingRoutingModule,
        SharedModule,
        NzCollapseModule,
        TitleCaseNoUnderScorePipe,
        NzSkeletonModule,
        NzPageHeaderModule,
        NzResultModule,
        NgxExtendedPdfViewerModule,
        AngularImageViewerModule,
    ],
})

export class BillingModule {}